import React from "react";

const Card = ({ children }) => (
	<div className="shadow-lg bg-white rounded-lg ">{children}</div>
);

export default Card;
